var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadarChartcolors(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 420 585",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f0adc7",
    d: "M236.66 360.81L72.54 454l164.12 96.14h110.7L454.18 454 375 311z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#df4b85",
    d: "M236.66 360.81L72.54 454l164.12 96.14h110.7L454.18 454 375 311z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M71.09 455l110.8-191 220.88-.42 110.07 190.61L402 645.26l-220.88.42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M123.24 454.79L207 310.38l166.93-.31 83.18 144.08-83.73 144.4-166.93.32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M180.56 453.89l55.78-96.19 111.18-.21 55.41 96-55.78 96.19-111.15.18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M237.43 454.48l27.19-46.89 54.2-.1 27 46.78-27.19 46.89-54.2.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M182.28 264.68l82.54 143.72"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M402.71 644.37l-82.54-143.72"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M402.71 264.68L319.2 407.43"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M182.28 644.37l83.51-142.75"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M512.45 454h-167"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M238.6 454h-167"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 236.66,
    cy: 356.93,
    r: 9.71,
    fill: "#df4b85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.71,
    cy: 311.71,
    r: 9.71,
    fill: "#df4b85"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.57,
    cy: 454.04,
    r: 9.71,
    fill: "#df4b85"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.71,
    cy: 548.71,
    r: 9.71,
    fill: "#df4b85"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 351.25,
    cy: 551.15,
    r: 9.71,
    fill: "#df4b85"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.18,
    cy: 454.27,
    r: 5,
    fill: "#2c2664"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 310,
    r: 5,
    fill: "#2c2664"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 358,
    r: 5,
    fill: "#2c2664"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeDasharray: "0.1 4",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M208 310l140.5 48.5 162 93.6-138.86 145.66-192.28 47.58L125 452.1z"
  })));
}

export default "data:image/svg+xml;base64,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";
export { SvgRadarChartcolors as ReactComponent };